import { useNavigate } from "react-router-dom";
import NumberFormat from "react-number-format";
import { TextField } from "@mui/material";

// import {Button} from "@mui/material";
// import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import moment from 'moment';

const ApplicationView = ({application}) => {
    const navigate = useNavigate()


    return(
        <section className="dashboard-form">
            <form noValidate autoComplete="off" >
                <div className="grouped-fields-light">
                    <TextField className="custom-input"
                        value={application?application.product_name:""}
                        label="Loan Product"
                        variant="outlined" 
                        fullWidth
                        InputProps={{ readOnly: true }}
                    />

                    <div style={{display: 'flex', gap: '10px'}}>
                        <NumberFormat   
                            value={application?application.amount:""}
                            className="custom-input"
                            fullWidth
                            label="Loan Amount" 
                            variant="outlined" 
                            customInput={TextField}
                            decimalScale={0}
                            fixedDecimalScale
                            decimalSeparator="."
                            isNumericString
                            thousandSeparator={true} 
                            InputProps={{ readOnly: true }}
                        />
                        <TextField className="custom-input"
                            value={application?application.term+""+application.term_unit_name:""}
                            label="Term" 
                            variant="outlined" 
                            fullWidth
                            InputProps={{ readOnly: true }}
                        />
                    </div>
                    <div style={{display: 'flex', gap: '10px'}}>
                        {/* <NumberFormat   
                            value={application?application.amount:""}
                            className="custom-input"
                            fullWidth
                            label="Application Date" 
                            variant="outlined" 
                            customInput={TextField}
                            decimalScale={0}
                            fixedDecimalScale
                            decimalSeparator="."
                            isNumericString
                            thousandSeparator={true} 
                            InputProps={{ readOnly: true }}
                        /> */}
                        <TextField className="custom-input"
                            value={application?moment(application.date).format("DD-MM-YYYY"):""}
                            label="Application Date" 
                            variant="outlined" 
                            fullWidth
                            InputProps={{ readOnly: true }}
                        />
                        <TextField className="custom-input"
                            value={application?application.status_name:""}
                            label="Status" 
                            variant="outlined" 
                            fullWidth
                            InputProps={{ readOnly: true }}
                        />
                    </div>
                </div>

                {/* <div className="grouped-fields-light">
                    <TextField className="custom-input"
                        label="Landlord"
                        variant="outlined" 
                        fullWidth
                        // defaultValue = {property.landlord}
                        defaultValue = {application.owner}

                        InputProps={{ readOnly: true }}
                    />

                </div> */}

            </form>

        </section>
    )
}

export default ApplicationView;